import { buildProductCard } from "./etempa-build-klevu-product-card.js";
import { arrayChunk } from "./etempa-klevu-helpers.js";
import { checkForMultipleVariants } from "./etempa-klevu-product-variants.js";

const klevu_js_key = "klevu-163067900222714176";

document.addEventListener("klevu:search-no-results", () => {
  console.log("[Klevu No Results Recs] Event received");

  const config = window.searchNoResultsRecsConfig;
  if (!config) {
    console.warn("[Klevu No Results Recs] searchNoResultsRecsConfig not found");
    return;
  }

  const unorderedList = document.querySelector(
    "[data-search-no-results-recs] .product-slider--product-recommendations"
  );
  if (!unorderedList) return;

  const sectionId = config.sectionId;
  const klevuLimit = config.klevuLimit;

  const priceData = {};
  let currencySymbol = "£";
  let changeCurrency = false;

  const request = {
    recordQueries: [
      {
        id: "noResultsRecs",
        typeOfRequest: "RECS_TRENDING",
        settings: {
          limit: klevuLimit,
          typeOfRecords: ["KLEVU_PRODUCT"],
        },
      },
    ],
    context: {
      apiKeys: [klevu_js_key],
    },
  };

  fetch("https://rwcsv2.ksearchnet.com/cs/v2/search", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(request),
  })
    .then((res) => {
      if (!res.ok) throw new Error(`Klevu API returned ${res.status}`);
      return res.json();
    })
    .then((data) => {
      console.log("No results recs data:", data);

      if (data.meta.responseCode !== 200) return;

      const queryResult = data.queryResults?.find((q) => q.id === "noResultsRecs");
      if (!queryResult?.records.length) return;

      const records = queryResult.records.filter((r) =>
        r.url.includes("rarewaves")
      );
      if (!records.length) return;

      const allHandles = records.map((r) => r.url.split("/").pop());
      const chunks = arrayChunk(allHandles, 20);

      chunks.forEach((chunk) => {
        fetch(`/?handles=${chunk.join("_")}&sections=etempa-product-has-variants`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        })
          .then((res) => res.json())
          .then((variantData) => {
            const tmpHTML = document.createElement("div");
            tmpHTML.innerHTML = variantData["etempa-product-has-variants"];
            const productVariantArray = tmpHTML.querySelector(
              "[data-product-variant-data]"
            );
            if (productVariantArray) {
              const productVariantData = JSON.parse(
                productVariantArray.innerText
              );
              if (productVariantData.product_data.length > 0) {
                checkForMultipleVariants(productVariantData.product_data);
              }
            }
          })
          .catch((err) => console.error("[Klevu No Results Recs]", err));
      });

      if (typeof current_currency !== "undefined" && current_currency !== "GBP") {
        changeCurrency = true;
        let filterMax = 0;
        let filterMin = 0;
        (queryResult.filters || []).forEach((filter) => {
          if (filter.key === "klevu_price") {
            filterMax = filter.max;
            filterMin = filter.min;
          }
        });

        let displayPriceDataCount = 0;
        chunks.forEach((chunk) => {
          const cacheBust = (Math.random() + 1).toString(36).substring(7);
          fetch(
            `/?handles=${chunk.join("_")}&sections=etempa-currency-conversion&max=${filterMax}&min=${filterMin}&type=${cacheBust}`,
            {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            }
          )
            .then((res) => res.json())
            .then((sectionData) => {
              const tmpElem = document.createElement("div");
              tmpElem.innerHTML = sectionData["etempa-currency-conversion"];
              const priceInfoArray = tmpElem.querySelectorAll(
                ".currency-conversion-price-info"
              );
              if (priceInfoArray.length > 0) {
                currencySymbol =
                  priceInfoArray[0].getAttribute("data-product-price")[0];
                priceInfoArray.forEach((priceInfo) => {
                  priceData[
                    parseInt(priceInfo.getAttribute("data-product-id").trim())
                  ] = {
                    price: priceInfo.getAttribute("data-product-price"),
                    comparePrice: priceInfo.getAttribute(
                      "data-product-compare-price"
                    ),
                  };
                });
              }
            })
            .catch((err) => console.error("[Klevu No Results Recs]", err));
        });

        const displayPriceData = setInterval(() => {
          displayPriceDataCount++;
          if (
            Object.keys(priceData).length === allHandles.length ||
            displayPriceDataCount > 20
          ) {
            clearInterval(displayPriceData);
            constructProducts(records, sectionId, changeCurrency, priceData, currencySymbol);
          }
        }, 250);
      } else {
        constructProducts(records, sectionId, changeCurrency, priceData, currencySymbol);
      }
    })
    .catch((err) => console.error("[Klevu No Results Recs]", err));
});

function constructProducts(records, sectionId, changeCurrency, priceData, currencySymbol) {
  const unorderedList = document.querySelector(
    "[data-search-no-results-recs] .product-slider--product-recommendations"
  );
  if (!unorderedList) return;

  records.forEach((product) => {
    const link = `/products/${product.url.split("/").pop()}`;
    buildProductCard(
      typeof collection_name !== "undefined" ? collection_name : null,
      typeof collection_handle !== "undefined" ? collection_handle : null,
      product,
      changeCurrency,
      priceData,
      currencySymbol,
      sectionId,
      typeof departmentMetaObject !== "undefined" ? departmentMetaObject : {},
      unorderedList,
      link,
      "product-slider--product-card-container"
    );
  });
}